<!--能耗计算对象 右键属性-->
<template>
  <div>
    <gs-modal v-loading="loading" v-model="visible" :before-close="beforeClose" :before-confirm="beforeConfirm"
      :title="isEdit ? '方波趋势' : '方波趋势'" :has-form="true" class="time-event-dialog-modal" top="15%" width="30%"
      @close="close" @confirm="handleConfirm">
      <gs-tabs v-model="activeName" type="content-tab">
        <gs-tab-pane label="常规" name="first">
          <gs-form :model="form" label-width="80px" label-position="left" gap="small">
            <gs-form-item label="名称" prop="target" class="form-item-radio">
              <gs-input ref="nameInput" v-model="name" />
            </gs-form-item>
            <gs-form-item label="描述" prop="target" class="form-item-radio">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="description">
              </el-input>
            </gs-form-item>
            <gs-form-item label="是否暂停">
              <gs-radio-group v-model="resource">
                <gs-radio label="1">是</gs-radio>
                <gs-radio label="2">否</gs-radio>
              </gs-radio-group>
            </gs-form-item>
          </gs-form>
        </gs-tab-pane>
        <gs-tab-pane label="数据选取" name="second">
          <div>
            <span @click="add" class="addTree">添加对象</span>
            <div class="form-item-objectSeries">
              <el-table :data="objectSeries" size="mini"
                :header-cell-style="{ background: '#343434', color: '#c7c7c9', border: '1px solid #4e4c4c' }"
                style="width: 100%">
                <el-table-column prop="name" label="名称" align="center">
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <i class="el-icon-delete" @click="delObjectSeriesArray(scope.row)"></i>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </gs-tab-pane>
      </gs-tabs>
      <span slot="footer" class="dialog-footer">
        <gs-button type="primary" size="mini" @click="handleConfirm">确 定</gs-button>
        <gs-button type="primary" size="mini" @click="beforeClose">取 消</gs-button>
        <!--   <gs-button type="primary"  size="mini">帮 助</gs-button> -->
      </span>
    </gs-modal>
    <gs-modal v-model="visibleAdd" :before-close="beforeCloseAdd" class="my-test-class" title="添加" @close="closeAdd"
      @confirm="handleConfirmAdd">
      <gs-tree v-if="visibleAdd" ref="tree" :data="addList" :props="props" :disable-node="true"
        :leaf-checkbox-only="true" :node-key="'id'" show-checkbox @check-change="checkEvent" />
    </gs-modal>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  components: {

  },
  data() {
    return {
      resource: "2",
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      visibleAdd: false,
      loading: false,
      activeName: 'first',
      name: '',
      description: '',
      form: {
        objectSeries: [],
      },
      isEdit: false,
      addList: [],
      objectSeries: [],
      pointIds: [],
      updateData: {},// 修改时的数据整体
    }
  },
  computed: {
    ...mapState({
      visible: 'squareDialogShow',
      nodeData: 'nodeTree',
      objectData: 'objectInfo'
    })
  },
  watch: {
    tableData() {
      this.form.objList = this.tableData
    },
    visible() {
      if (this.visible) {
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        this.activeName = 'first'
        this.objectInfo = JSON.parse(JSON.stringify(this.objectData));
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'squareWave') {
          this.isEdit = false
          service.getNode(this.objectData.id).then(res => {
            this.updateData = res
            this.form = res.attribute ? res.attribute : {}
            this.description = res.description
            this.name = res.name
            res.attribute.isPause ? this.resource = "1" : this.resource = "2"
            this.objectSeries = res.attribute.objectSeries
            this.pointIds = res.attribute.pointIds
          })

        } else {
          this.isEdit = true
          this.form = {}
          this.description = ''
          this.name = ''
          this.objectSeries = []
          this.resource = "2"
        }
      } else {
        this.isEdit = true
        this.form = {}
        this.description = ''
        this.name = ''
        this.objectSeries = []
        this.resource = "2"
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    ...mapMutations({
      close: 'SQUARE_DIALOG_HIDE'
    }),
    //主  
    beforeClose() {
      this.close()
      this.resource = "2"
    },
    handleConfirm() {
      let _this = this
      let isPauseWeb = false
      if (this.isEdit) {
        if (this.name != "") {
          this.resource == "2" ? isPauseWeb = false : this.resource == "1" ? isPauseWeb = true : ""
          let obj = {
            name: this.name,
            type: "squareWave",
            parentId: this.nodeData.id,
            description: this.description,
            label: [],
            operationTime: null,
            timeStamp: "",
            sort: 100,
            attribute: {
              pointIds: this.pointIds,
              isPause: isPauseWeb,
              objectSeries: this.objectSeries,
            }
          }
          console.log(obj, "创建时候的数据")
          service.newAddPoint(obj).then(res => {
            this.$message.success("创建成功")
            this.resource = "2"
            this.close()
          }).catch(err => {
            this.$message.error("创建失败")
            this.resource = "2"
          })
        } else {
          this.$Message.info("请填写完整信息！")
        }
      } else {
        this.resource == "2" ? isPauseWeb = false : this.resource == "1" ? isPauseWeb = true : ""
        this.updateData.name = this.name,
          this.updateData.description = this.description,
          this.updateData.attribute.isPause = isPauseWeb
        this.updateData.attribute.objectSeries = this.objectSeries
        this.updateData.attribute.pointIds = this.pointIds
        service.renamePoint(this.updateData).then(res => {
          this.$message.success("修改成功")
          this.$store.state.updateTreeNode = res;
          this.close()
        }).catch(err => {
          this.$message.error("修改失败")
        })
      }
    },
    beforeConfirm(e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    add() {
      let _this = this
      let id = ''
      if (_this.nodeData.type === 'device') {
        id = _this.nodeData.id
      } else {
        id = _this.nodeData.parentId
      }
      this.visibleAdd = true
      if (this.nodeData.type == "logicalGroup") {
        service.getTree('', this.nodeData.id).then(res => {
          res[0].children.forEach(item => {
            service.getTree('Point', item.id).then(restree => {
              item.children = restree[0].children
            })
          })
          setTimeout(() => {
            _this.addList = res;
          }, 2000)

        })
      }
      else if (this.nodeData.type == "server") {
        service.getAllTree().then(res => {
          _this.addList = res;
        })
      }
      else {
        service.getTree('Point', id).then(res => {
          _this.addList = res
          if (_this.objectSeries !== null && _this.objectSeries.length > 0) {
            setTimeout(() => {
              _this.objectSeries.forEach(res => {
                _this.$refs.tree.setChecked(res.id, true)
              })
            }, 0)
          }
        })
      }

    },
    delObjectSeriesArray(val) {
      this.objectSeries.forEach((value, index, array) => {
        if (val.name === value.name) {
          this.objectSeries.splice(index, 1);
        }
      })
    },
    beforeCloseAdd() {
      this.visibleAdd = false
    },
    checkEvent(node, isSelect, halfSelect) {
      switch (node.type) {
        case 'value_Analog':
          break
        case 'value_Multistate':

          break
        case 'value_Binary':

          break
        case 'value_String':

          break
        case 'BinaryInput':

          break
        case 'BinaryOutput':

          break
        case 'AnalogInput':

          break
        case 'AnalogOutput':

          break
        case 'trendLog':

          break
        case 'AnalogR':

          break
        case 'AnalogW':

          break
        case 'BinaryR':

          break
        case 'BinaryW':

          break
        case 'IntegerR':

          break
        case 'IntegerW':

          break
        case 'BinaryInputW':

          break
        case 'BinaryInputR':

          break
        case 'BinaryOutputW':

          break
        case 'BinaryOutputR':

          break
        case 'AnalogInputW':

          break
        case 'AnalogInputR':

          break
        case 'AnalogOutputW':

          break
        case 'AnalogOutputR':

          break
        case 'DigitalOutputW':

          break
        case 'DigitalOutputR':

          break
        case 'DigitalInputW':

          break
        case 'DigitalInputR':

          break
        case 'EnergyCalculation':

          break

        case 'BatchEnergyMetrics':
          break

        default:
          this.$Message.error('此节点为目录，无法被选择')
          this.$refs.tree.setChecked(node.id, false)
          break
      }
    },
    handleConfirmAdd() {
      this.pointIds = []
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        this.objectSeries.push(e.data)
        this.pointIds.push(e.data.id)
      })
      this.objectSeries = this.unique(this.objectSeries, 'id')
      this.visibleAdd = false
      console.log(this.pointIds)
    },
    unique(arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    closeAdd() {
      this.visibleAdd = false
    }
  }
}
</script>
<style>
/* .gs-form-item {
  margin-bottom: 0px !important;
} */
</style>
<style scoped>
.addTree {
  cursor: pointer;
  color: rgb(248, 121, 1);
}

.inp>>>.gs-input,
.gs-input-number {
  height: 26px;
}

.gs-modal-wrap {
  top: 11%;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 45%;
  float: left;
  margin-right: 20px;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.seventy-part {
  box-sizing: border-box;
  float: left;
  width: 65%;
}

.thirty-part {
  box-sizing: border-box;
  float: left;
  width: 100%;
}

.event-btn {
  margin: 10px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.fifty-width-box {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  /* Firefox */
  -webkit-box-sizing: border-box;
  /* Safari */
  width: 47%;
  float: left;
  margin-right: 13px;
}

fieldset {
  padding: 12px;
  border-radius: 5px;
  border: solid 2px #d9d9d9;
}

.bottom-btn {
  margin: 20px;
  text-align: center;
}

.form-item-objectSeries {
  height: 250px;
  overflow: auto;
  margin-bottom: 12px;
  padding: 12px;
  border: solid 1px #d9d9d9;
  border-radius: 1px;
}

.form-item-objectSeries>>>.gs-form-item {
  margin-bottom: 0px m !important;
}
</style>



// WEBPACK FOOTER //
// src/components/timeChart/squareDialog.vue